export default {
  allFinancialSubCategories: [],
}
